<template>
    <div class="page-content">
        <div class="page-body">
            <div class="page-left">
                <div class="body-item">
                    <div class="f-16 mb-10 fw-b">确认订单信息</div>
                    <el-form label-width="100px" label-position="right">
                        <el-form-item style="margin: 0;" label="服务类型：">{{form.type<=1?'接机':'送机'}}</el-form-item>
                        <el-form-item style="margin: 0;" label="目的地：">{{form.site}}</el-form-item>
                        <el-form-item style="margin: 0;" :label="`${form.type<=1?'接机':'送机'}时间：`">{{form.time}}
                        </el-form-item>
                        <el-row :gutter="20">
                            <el-col :span="7">
                                <el-form-item style="margin: 0;" label="人数：" required>
                                    <el-select v-model="form.people" placeholder="请选择人数" filterable
                                               style="width: 160px">
                                        <el-option v-for="(item,index) in newNum"
                                                   :key="index"
                                                   :label="`${item}人`"
                                                   :value="item"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item style="margin: 0;" label="行李：" required>
                                    <el-select v-model="form.luggage" placeholder="请选择人数" filterable
                                               style="width: 160px">
                                        <el-option label="无" :value="0"></el-option>
                                        <el-option v-for="(item,index) in numAry"
                                                   :key="index"
                                                   :label="`${item}件`"
                                                   :value="item"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <div class="body-item">
                    <div class="f-16 mb-10 fw-b">确认订单信息</div>
                    <el-form label-width="100px" label-position="right">
                        <el-form-item label="联系人：" required>
                            <el-input placeholder="请输入联系人" v-model="contact" style="width: 220px;"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号：" required>
                            <el-input placeholder="请输入手机号" v-model="telphone" style="width: 220px;"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="body-item">
                    <div class="f-16 mb-10 fw-b">其他信息</div>
                    <el-form label-width="100px" label-position="right">
                        <el-form-item v-if="form.type===2" label="协办登机：" required>
                            <el-switch
                                    v-model="help"
                                    :active-value="1"
                                    :inactive-value="0"
                                    active-text="是"
                                    inactive-text="否">
                            </el-switch>
                        </el-form-item>
                        <el-form-item label="备注信息：">
                            <el-input v-model="remark" placeholder="可选填留言备注信息，如：是否需要儿童座椅，对车辆清洁要求等"
                                      type="textarea"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="body-item">
                    <div class="f-16 mb-20 fw-b">订单规则</div>
                    <div class="f-14 mb-10 ml-30" v-for="(item,index) in driverRules" :key="index">{{item.title}}</div>
                </div>
                <div style="width: 100%;display: flex;justify-content: center;align-items: center">
                    <el-button type="primary" class="mt-30 mb-20" @click="showPay">确认订单，前往付款
                    </el-button>
                </div>

            </div>
            <div class="page-right">
                <div class="page-right-item">
                    <div class="right-title">订单信息</div>
                    <div class="right-item-info"><strong class="color-red"> {{+form.price|parseMoney}}/车</strong>&emsp;{{form.seats-1}}人止
                    </div>
                    <div class="right-item-row">
                        <div class="item-row-label">基本费用</div>
                        <div class="item-row-text">{{+form.price|parseMoney}}</div>
                    </div>
                    <div v-if="+this.form.type === 2 && this.help === 1" class="right-item-row">
                        <div class="item-row-label">协办登机</div>
                        <div class="item-row-text">{{100|parseMoney}}</div>
                    </div>
                    <div class="right-item-row">
                        <div class="item-row-label">合计费用</div>
                        <div class="item-row-text f-20 color-red">{{totalPrice|parseMoney}}</div>
                    </div>
                </div>
                <div class="page-right-item">
                    <div class="right-title">导游信息</div>
                    <div class="right-user cur-p" @click="toDriverDetail">
                        <img class="right-user-img" :src="`/api/v1/file/${form.portrait}`" alt="">
                        <div class="right-user-name">{{form.nickname}}</div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog :visible.sync="showPayDialog">
            <PayCar :price="totalPrice" :orderMum="orderNum"></PayCar>
        </el-dialog>

    </div>
</template>

<script>
    import PayCar from "../components/PayCar";
    export default {
        name: "shuttlePay",
        components:{PayCar},
        data() {
            return {
                loading: false,
                showPayDialog: false,
                numAry: Array.from({length: 15}, (item, index) => index + 1),
                form: {
                    type: 1,
                    flight: '',
                    site: '',
                    time: '',
                    people: 1,
                    luggage: 0,
                    airport: '',
                    area: '',
                },
                contact: '',
                telphone: '',
                remark: '',
                help: 0,
                driverRules: [],
                orderNum: ''
            }
        },
        created() {
            this.form = this.$store.state.shuttle.payInfo;
            this.getDriverRules();
        },
        computed: {
            newNum() {
                if (this.form.seats) {
                    return this.numAry.filter(it => it <= this.form.seats - 1)
                }
                return this.numAry
            },
            totalPrice() {
                if (+this.form.type === 2 && this.help === 1) {
                    return this.form.price * 1 + 100;
                }
                return +this.form.price
            }
        },
        methods: {
            async getDriverRules() {
                let [e, data] = await this.$api.getDriverRulesApi();
                this.driverRules = data.result;
            },
            async showPay() {
                let forms = {
                    driver_id: this.form.user_id,
                    airport_id: this.form.airport,
                    area_id: this.form.area,
                    site: this.form.site,
                    flight: this.form.flight,
                    time:  this.form.time,
                    people: this.form.people,
                    bags: this.form.luggage,
                    type: this.form.type,
                    contact: this.contact,
                    telphone: this.telphone,
                    remark: this.remark,
                    price: this.form.price,
                    price_all: this.form.price,
                    is_help: this.help,
                }
                this.loading = true;
                let [e, data] = await this.$api.carSlipAddApi(forms)
                this.loading = false;
                if(data.status){
                    this.orderNum = data.result;
                    this.showPayDialog = true;
                }else {
                    this.$message.warning(data.msg)
                }

            },
            toDriverDetail() {
                this.$router.push({path: '/driverDetail', query: {id: this.form.user_id}})
            }
        },
    }
</script>

<style scoped lang="less">
    .page-content {
        padding: 20px;
        box-sizing: border-box;

        .page-body {
            width: 1200px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin: auto;

            .page-left {
                width: 900px;
                margin-right: 20px;
                background-color: #ffffff;
                box-shadow: 3px 3px 6px #A6A6A6;

                .body-item {
                    padding: 20px;
                    box-sizing: border-box;
                    border-bottom: 1px solid #e2e2e2;
                    text-align: left;

                    &:last-child {
                        border-bottom: none;
                    }
                }
            }

            .page-right {
                flex: 1;

                .page-right-item {
                    width: 100%;
                    background-color: #ffffff;
                    box-shadow: 3px 3px 6px #A6A6A6;
                    margin-bottom: 20px;
                    padding: 20px;
                    box-sizing: border-box;

                    .right-item-info {
                        text-align: right;
                        color: #949494;
                        margin-bottom: 10px;
                    }

                    .right-item-row {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 50px;
                        border-top: 1px solid #e2e2e2;
                    }

                    .right-user {
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        height: 60px;

                        &:hover {
                            .right-user-name {
                                color: #e44646;
                            }
                        }

                        .right-user-img {
                            width: 50px;
                            height: 50px;
                            border-radius: 100%;
                            object-fit: cover;
                        }

                        .right-user-name {
                            margin-left: 20px;
                            font-size: 18px;
                            font-weight: bold;

                        }
                    }
                }
            }
        }
    }
</style>
